import { Layout } from "@/components/layout";
import { SiGithub, SiX, SiLinkedin } from "react-icons/si";
import { HiOutlineMail } from "react-icons/hi";
import { Heading, Paragraph } from "@/components/Typography";

export function Hero() {
  return (
    <Layout>
      <Heading level="h2" className="text-center">Welcome!</Heading>
      <Paragraph className="text-center text-lg text-gray-600 dark:text-gray-400">
      This is my little corner of the internet where I build, write, and share things I find interesting.
      </Paragraph>

      <div className="mt-8 flex flex-col items-center space-y-4">
        <a href="/projects" className="text-blue-500 hover:underline text-lg">🛠 Explore my projects</a>
        <a href="/blog" className="text-blue-500 hover:underline text-lg">📝 Read my thoughts</a>
      </div>

      {/* Social Links */}
      <div className="mt-12 flex justify-center gap-6 text-gray-600 dark:text-gray-400">
        <a href="https://github.com/andrediasesp" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 dark:hover:text-white transition-colors">
          <SiGithub className="h-6 w-6" />
        </a>
        <a href="https://twitter.com/andrepldias" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 dark:hover:text-white transition-colors">
          <SiX className="h-6 w-6" />
        </a>
        <a href="https://linkedin.com/in/andrediasesp" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 dark:hover:text-white transition-colors">
          <SiLinkedin className="h-6 w-6" />
        </a>
        <a href="mailto:andrepldias@gmail.com" className="hover:text-gray-900 dark:hover:text-white transition-colors">
          <HiOutlineMail className="h-6 w-6" />
        </a>
      </div>
    </Layout>
  );
}